import { render, staticRenderFns } from "./Bankaccounts.vue?vue&type=template&id=6b30bf69&"
import script from "./Bankaccounts.vue?vue&type=script&lang=js&"
export * from "./Bankaccounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports